import { createAction, createReducer } from '@reduxjs/toolkit';
import { SecretsVault } from '../../types/rest/mockServiceTypes';
import { SecretsVaultState } from './secretsTypes';

export const updateSecretsVaultList = createAction<SecretsVault[] | null>('UPDATE_SECRETS_LIST');

export class EmptySecretsVault implements SecretsVault {
  id = null;
  integrationName = '';
}

const initialState: SecretsVaultState = {
  secretsVaultList: [],
};

export const secretsVaultReducer = createReducer(initialState, builder => {
  builder.addCase(updateSecretsVaultList, (state, action) => {
    state.secretsVaultList = action.payload;
  });
});
